import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Stack,
    IconButton,
    Checkbox,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { ImagePaths } from "../../../Utility/ImagePaths";
import { AmountFormat } from "../../../Components/CommonFunctions/CommonFunctions";
import Loader from "../../../Components/Loader";
import { CurrencySymbol } from "../../../Utility/Constants";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { DateTime } from "luxon";

const StorePurchaseReturn = () => {
    const history = useHistory();
    const location = useLocation();
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [PruchaseReqData, setPruchaseReqData] = useState([]);
    const [disableBtn, setDisbleBtn] = useState(false)
    const [isloader, setisloader] = useState(false);


    const [vendorFormData, setVendorFormData] = useState({
        vendor_name: "",
        invoice_number: "",
        bill_date: DateTime.local().toISODate(),
        bill_amount: "",
        taxable_amount: "",
        cgst: "",
        sgst: "",
    });

    useEffect(() => {
        if (location.states?.inward_details && location.states?.bill_details) {
            getInwardDetails(location.states?.inward_details?.id)
        }
    }, []);

    useEffect(() => {
        if (disableBtn) {
            postPurchaseReturn()
        }
    }, [disableBtn]);

    const getInwardDetails = (InwardId = null) => {
        try {
            let VendorBillId = location?.states?.bill_details?.vendor_bill_id ? location?.states?.bill_details?.vendor_bill_id : ""
            RestAPIService.getAll(`${Serviceurls.STORE_PURCHASE_INWARD}?inward_id=${InwardId}&vendor_bill_id=${VendorBillId}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let StockList = response?.data?.data?.length ? response?.data?.data[0]?.stock_items : []
                        setPruchaseReqData(StockList)
                        setVendorFormData((prevData) => ({
                            ...prevData,
                            vendor_name: location.states?.inward_details?.vendor_name ? location.states?.inward_details?.vendor_name : ""
                        }))
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const handleCheckChange = (id) => {
        setPruchaseReqData((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? {
                    ...row,
                    selected: !row.selected,
                    returnQty: ""
                } : row
            )
        );
    };

    const handleTextChange = (id, value) => {
        const numericValue = +value;

        setPruchaseReqData((prevRows) =>
            prevRows.map((row) => {
                if (row.id !== id) return row;

                const {
                    available_quantity,
                    buying_price_per_quantity,
                    discount_percentage,
                    cgst_percentage,
                } = row;

                const isValidQty = numericValue <= available_quantity;
                const buyingPrice = +buying_price_per_quantity || 1;

                const baseAmount = numericValue * buyingPrice;

                const discount = discount_percentage
                    ? CommonValidation.calculatePercentage(baseAmount, discount_percentage)
                    : 0;

                const taxableAmount = isValidQty ? baseAmount : row.taxable_amount;

                const gstAmount = isValidQty
                    ? ((baseAmount - discount) * (cgst_percentage * 2)) / 100
                    : row.gst_amount;

                const billAmount = isValidQty
                    ? (baseAmount - discount) + gstAmount
                    : row.bill_amount;

                return {
                    ...row,
                    returnQty: isValidQty ? numericValue : row.returnQty,
                    taxable_amount: taxableAmount,
                    gst_amount: gstAmount,
                    bill_amount: billAmount,
                };
            })
        );
    };


    const columns = [
        {
            field: "select",
            headerName: "",
            flex: 0.03,
            renderCell: (params) => (
                <Checkbox
                    disabled={!params?.row?.available_quantity}
                    checked={params.row.selected || false}
                    onChange={() => handleCheckChange(params.row.id)}
                />
            ),
        },
        { field: "product_code", headerName: "Product Code", flex: 0.06 },
        { field: "product_name", headerName: "Product Name", flex: 0.09 },
        { field: "department_name", headerName: "Department", flex: 0.09 },
        // { field: "category_name", headerName: "Category", flex: 0.09 },
        // { field: "sub_category_name", headerName: "Sub Category", flex: 0.06 },
        // { field: "product_type_name", headerName: "Product Type", flex: 0.06 },
        { field: "batch_no", headerName: "Batch No", flex: 0.06 },
        { field: "hsn_code", headerName: "HSN Code", flex: 0.06 },
        { field: "stock_in_quantity", headerName: "PO Qty", flex: 0.05 },
        { field: "available_quantity", headerName: "Aval Qty", flex: 0.05 },
        {
            field: "returnQty",
            headerName: "Return Qty",
            flex: 0.06,
            renderCell: (params) => (
                <TextField
                    size="small"
                    disabled={!params.row.selected}
                    value={params.row.returnQty}
                    onChange={(e) => handleTextChange(params.row.id, e.target.value)}
                />
            ),
        },
        {
            field: "buying_price_per_quantity", headerName: "PV" + `(${CurrencySymbol})`, flex: 0.05, type: "number",
            renderCell: (params) => (
                <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
                    <Typography>{params?.row?.buying_price_per_quantity ? AmountFormat(params?.row?.buying_price_per_quantity)?.replace(`${CurrencySymbol}`, "") : AmountFormat(0)?.replace(`${CurrencySymbol}`, "")}</Typography>
                </Box>)
        },
        { field: "discount_percentage", headerName: "Dis %", flex: 0.06 },
        {
            field: "gst_amount", headerName: "GST Amt" + `(${CurrencySymbol})`, flex: 0.05, type: "number",
            renderCell: (params) => (
                <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
                    <Typography>{params?.row?.gst_amount ? AmountFormat(params?.row?.gst_amount)?.replace(`${CurrencySymbol}`, "") : AmountFormat(0)?.replace(`${CurrencySymbol}`, "")}</Typography>
                </Box>)
        },
        {
            field: "bill_amount", headerName: "Net Amount" + `(${CurrencySymbol})`, flex: 0.09, type: "number",
            renderCell: (params) => (
                <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
                    <Typography>{params?.row?.bill_amount ? AmountFormat(params?.row?.bill_amount)?.replace(`${CurrencySymbol}`, "") : AmountFormat(0)?.replace(`${CurrencySymbol}`, "")}</Typography>
                </Box>)
        }
    ];

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const errorMessage = (msg) => {
        setisloader(false)
        setDisbleBtn(false)
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setisloader(false)
        setDisbleBtn(false)
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    useEffect(() => {
        setVendorFormData((prevData) => ({
            ...prevData,
            taxable_amount: +(PruchaseReqData.reduce((acc, vendor) => acc + (vendor.taxable_amount ? +vendor.taxable_amount : 0), 0)),
            bill_amount: +(PruchaseReqData.reduce((acc, vendor) => acc + (vendor.bill_amount ? vendor.bill_amount : 0), 0)),
            cgst: +(PruchaseReqData.reduce((acc, vendor) => acc + (vendor.gst_amount ? (+vendor.gst_amount / 2) : 0), 0)),
            sgst: +(PruchaseReqData.reduce((acc, vendor) => acc + (vendor.gst_amount ? (+vendor.gst_amount / 2) : 0), 0)),
        }))
    }, [PruchaseReqData]);

    const postPurchaseReturn = () => {
        try {
            if (!vendorFormData?.invoice_number) {
                errorMessage('Please Enter Invoice Number')
            } else if (PruchaseReqData?.every((list) => (!list?.selected))) {
                errorMessage(`Select the items for return`)
            } else if (PruchaseReqData?.some((list) => (list?.selected && !list?.returnQty))) {
                errorMessage(`Enter the return quantity for selected items`)
            } else {
                let LineItems = []
                PruchaseReqData?.forEach((list) => {
                    if (list?.selected) {
                        LineItems.push({
                            'stock_id': list?.id ? list?.id : null,
                            'product_id': list?.product_id ? list?.product_id : null,
                            'net_amount': list?.bill_amount ? +list?.bill_amount : 0,
                            'cgst_amount': list?.gst_amount ? (+list?.gst_amount / 2) : 0,
                            'sgst_amount': list?.gst_amount ? (+list?.gst_amount / 2) : 0,
                            'taxable_amount': list?.taxable_amount ? list?.taxable_amount : 0,
                            'return_quantity': list?.returnQty ? +list?.returnQty : 0,
                            'discount_percentage': list?.discount_percentage ? list?.discount_percentage : 0,
                            'discount_amount': list?.discount_amount ? list?.discount_amount : 0
                        })
                    }
                })
                let VendorBillId = location?.states?.bill_details?.vendor_bill_id ? location?.states?.bill_details?.vendor_bill_id : ""
                let data = {
                    'inward_id': (location.states?.inward_details?.id) ? location.states?.inward_details?.id : null,
                    'vendor_bill_id': VendorBillId,
                    'vendor_id': location.states?.inward_details?.vendor_id ? location.states?.inward_details?.vendor_id : null,
                    'vendor_bill_number': vendorFormData?.invoice_number,
                    'return_date': vendorFormData?.bill_date ? DateTime.fromISO(vendorFormData?.bill_date).toFormat('yyyy-MM-dd') : '',
                    'taxable_amount': vendorFormData?.taxable_amount,
                    'cgst_amount': vendorFormData?.cgst,
                    'sgst_amount': vendorFormData?.sgst,
                    'net_amount': vendorFormData?.bill_amount,
                    'lines': LineItems
                }
                setisloader(true)
                RestAPIService.create(data, Serviceurls.STORE_PURCHASE_RETURN)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            setDisbleBtn(false)
                            setisloader(false)
                            history.push({ pathname: "/StorePurchase/PurchaseInward", states: { success_message: response.data.message } })
                        }
                    }).catch(e => {
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const onChangeHandlerVendor = (event, name, maxLength) => {
        if (maxLength >= event.target.value?.length) {
            setVendorFormData((prevData) => ({
                ...prevData,
                [name]: event.target.value,
            }));
        }
    };


    const rendertable = () => {
        PruchaseReqData?.forEach((element, index) => element.sno = index + 1)
        return (
            <DataGrid rows={PruchaseReqData} columns={columns} disableSelectionOnClick hideFooter density="compact" />
        )
    }

    const datetextBox = (label, name, val, type, disable = false, MaxLength = 30) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    value={val ? val : null}
                    id="drug-master"
                    type={type}
                    sx={{ width: '12.5dvw', marginRight: '0.3vw' }}
                    label={label}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ min: new Date().toISOString().split("T")[0], max: name === "expiryDate" ? null : new Date().toISOString().split("T")[0] }} // Disable future dates
                    variant="outlined"
                />
            </Box>
        )
    }
    const VendortextBox = (label, name, val, type, disable = false, MaxLength = 30) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    inputProps={{ maxLength: MaxLength }}
                    value={val ? val : ""}
                    id="drug-master"
                    type={type}
                    sx={{ width: '12.5dvw', marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandlerVendor(e, name, MaxLength) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    return (
        <Box sx={{}}>
            <Box component={'div'} className='eMed_Pharma_Header_Card' sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', height: "7dvh" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton size="small" onClick={() => {
                        history.push({ pathname: '/StorePurchase/PurchaseInward' })
                    }} >
                        <img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} />
                    </IconButton>
                    <Typography sx={{ color: "#616161" }}> {"Back to Purchase Inward Home"}</Typography></Stack>
                <Button sx={{ textTransform: 'capitalize' }} disabled={disableBtn} size="small" variant="contained" onClick={() => { setDisbleBtn(true) }}>Make Return</Button>
            </Box>
            {/* Vendor Details */}
            <Box sx={{ height: '78dvh', overflow: 'auto' }}>
                <Box sx={{ marginBottom: "0.5vw" }}>
                    <Typography fontSize={"1vw"} gutterBottom>
                        Vendor Details
                    </Typography>
                    <Box sx={{ display: "flex", height: '6vw', flexWrap: 'wrap', alignItems: 'center' }}>
                        {VendortextBox("Vendor *", "vendor_name", vendorFormData.vendor_name, "text", true)}
                        {VendortextBox("Invoice No *", "invoice_number", vendorFormData.invoice_number, "text", false)}
                        {datetextBox("Bill Date", "bill_date", vendorFormData.bill_date, "date", true)}
                        {VendortextBox("CGST", "cgst", (vendorFormData.cgst ? +(vendorFormData.cgst).toFixed(2) : 0), "number", true, 2)}
                        {VendortextBox("SGST", "sgst", (vendorFormData.sgst ? +(vendorFormData.sgst).toFixed(2) : 0), "number", true, 2)}
                        {VendortextBox("Bill Amount", "bill_amount", (vendorFormData.bill_amount ? +(vendorFormData.bill_amount).toFixed(2) : 0), "number", true, 7)}
                    </Box>
                </Box>
                <Box sx={{ height: "100%", marginTop: "20px" }}>
                    {rendertable()}
                </Box>
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isloader ? <Loader loaderOpen={isloader} /> : null}

        </Box>
    );
};

export default StorePurchaseReturn;
